import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { trackPageView } from '../lib/page-tracking';

/**
 * SDA-299: log one page view per pathname change. Query-string-only changes
 * (e.g. re-searching /events) are not new pages. The ref skips StrictMode's
 * repeated effect for the same path. Waits for the saved session to restore, so
 * a logged-in admin's first page isn't sent without their token (and logged as
 * an anonymous visitor).
 */
export function usePageTracking(): void {
  const { pathname } = useLocation();
  const { getAccessToken, isLoading } = useAuth();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    if (isLoading || lastPath.current === pathname) return;
    lastPath.current = pathname;
    trackPageView(pathname, getAccessToken());
    // getAccessToken is read at the moment of the page change, not tracked.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, isLoading]);
}
